import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import InputMask from 'react-input-mask';

import {
  Box,
  Typography,
  Grid,
  FormControl,
  TextField,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import ScheduleButton from '../../components/ScheduleButton';
import ScheduleLink from '../../components/ScheduleLink';
import ScheduleModal from '../../components/ScheduleModal';
import AvailableDateCard from '../../components/AvailableDateCard';
import AddressAlert from '../../components/AddressAlert';
import ModalError from '../../components/ModalError';
import Loading from '../../components/Loading';

import SchedulingFormStore from '../../stores/SchedulingFormStore';
import AvailableDatesStore from '../../stores/AvailableDatesStore';
import ModalStore from '../../stores/ModalStore';

const schedulingFormStyles = ({ breakpoints }) => ({
  root: {
    '& .MuiGrid-container': {
      marginTop: '16px',
      '& .MuiFormControl-root': {
        marginRight: '16px',
        [breakpoints.down('xs')]: {
          marginBottom: '16px',
        },
        '& .MuiFormLabel-root.Mui-focused': {
          color: '#0086FF',
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#0086FF',
        },
      },
    },
  },
  boxButton: {
    marginTop: '64px',
    [breakpoints.down('xs')]: {
      marginTop: '24px',
    },
  },
  boxButtonsModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
    marginTop: '40px',
    '& a': {
      marginRight: '40px',
    },
  },
});

class SchedulingForm extends Component {
  handleScheduleAssemblyClick = () => {
    const {
      availableDatesStore,
      schedulingFormStore,
      modalStore,
      scrollToErrorMessage,
    } = this.props;

    const selectedSchedulingDate = availableDatesStore.getSelectedDate();

    if (!selectedSchedulingDate) {
      availableDatesStore.handleError(true);
      scrollToErrorMessage();
    } else {
      availableDatesStore.handleError(false);
      schedulingFormStore.setSelectedSchedulingDate(selectedSchedulingDate);
      modalStore.openModal();
    }
  };

  handleCloseModal = event => {
    const { modalStore } = this.props;

    event.preventDefault();

    modalStore.closeModal();
  };

  render() {
    const { classes, schedulingFormStore, customer, schedules } = this.props;
    const {
      isLoading,
      isFailure,
      name,
      phone,
      complement,
      referencePoint,
      selectedSchedulingDate,
      handleChangeInput,
      handleConfirmSchedulingClick,
    } = schedulingFormStore;

    return (
      <>
        {isLoading && (
          <Loading message="Estamos finalizando seu agendamento :)" />
        )}

        <Box mt={8} className={classes.root}>
          <Typography component="div">
            <Box fontSize={21} fontWeight="bold">
              3. Informações adicionais (opcional)
            </Box>
            <Box fontSize={16} fontWeight="bold" mt={2}>
              Quem receberá o montador?
              <Grid container>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="Nome"
                      name="name"
                      variant="outlined"
                      value={name.value}
                      helperText={`${name.count}/50`}
                      inputProps={{ maxLength: 50 }}
                      onChange={event => handleChangeInput('name', event)}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <FormControl fullWidth>
                    <InputMask
                      mask="(99) 99999-9999"
                      value={phone.value}
                      onChange={event => handleChangeInput('phone', event)}
                    >
                      {() => (
                        <TextField
                          label="Telefone"
                          name="phone"
                          variant="outlined"
                          value={phone.value}
                        />
                      )}
                    </InputMask>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box fontSize={16} fontWeight="bold" mt={2}>
              Informações complementares do seu endereço
              <Grid container>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="Complemento"
                      name="complement"
                      variant="outlined"
                      value={complement.value}
                      helperText={`${complement.count}/50`}
                      inputProps={{ maxLength: 50 }}
                      onChange={event => handleChangeInput('complement', event)}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="Ponto de referência"
                      name="referencePoint"
                      variant="outlined"
                      value={referencePoint.value}
                      helperText={`${referencePoint.count}/50`}
                      inputProps={{ maxLength: 50 }}
                      onChange={event =>
                        handleChangeInput('referencePoint', event)
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.boxButton}>
              <ScheduleButton
                size="large"
                onClick={() => this.handleScheduleAssemblyClick()}
              >
                Agendar montagem
              </ScheduleButton>
            </Box>
          </Typography>
        </Box>
        <ScheduleModal maxWidth="md" title="Confirmação">
          <Box>
            <Box mb={2}>
              <Typography component="div">
                <Box fontWeight="bold" fontSize="16px">
                  Confirmar agendamento de montagem?
                </Box>
              </Typography>
            </Box>
            <Grid container>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                {selectedSchedulingDate.date && (
                  <AvailableDateCard
                    date={selectedSchedulingDate.date}
                    selected={selectedSchedulingDate.selected}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                <Typography component="div">
                  {name.value && (
                    <>
                      <Box fontWeight="bold" fontSize="16px">
                        Quem recebe o montador:
                      </Box>
                      <Box fontSize="16px">{name.value}</Box>
                    </>
                  )}
                  {phone.value && (
                    <>
                      <Box fontWeight="bold" fontSize="16px" mt={2}>
                        Telefone:
                      </Box>
                      <Box fontSize="16px">{phone.value}</Box>
                    </>
                  )}
                  {complement.value && (
                    <>
                      <Box fontWeight="bold" fontSize="16px" mt={2}>
                        Complemento:
                      </Box>
                      <Box fontSize="16px">{complement.value}</Box>
                    </>
                  )}
                  {referencePoint.value && (
                    <>
                      <Box fontWeight="bold" fontSize="16px" mt={2}>
                        Ponto de referência:
                      </Box>
                      <Box fontSize="16px" mb={2}>
                        {referencePoint.value}
                      </Box>
                    </>
                  )}
                  <Box fontWeight="bold" fontSize="16px">
                    Horário:
                  </Box>
                  <Box fontSize="16px">Entre 8:00 e 18:00hrs</Box>
                  <Box fontWeight="bold" fontSize="16px" mt={2}>
                    Endereço da montagem:
                  </Box>
                  <Box fontSize="16px">{customer.address}</Box>
                  <AddressAlert />
                </Typography>
              </Grid>
            </Grid>
            <Box className={classes.boxButtonsModal}>
              <ScheduleLink onClick={this.handleCloseModal}>
                Voltar
              </ScheduleLink>
              <ScheduleButton
                onClick={() =>
                  handleConfirmSchedulingClick(schedules, customer.name)
                }
              >
                Confirmar
              </ScheduleButton>
            </Box>
          </Box>
        </ScheduleModal>
        {isFailure && (
          <ModalError title="Erro">
            <Box className={classes.boxButtonsModal}>
              <ScheduleButton
                onClick={() =>
                  handleConfirmSchedulingClick(schedules, customer.name)
                }
              >
                Tentar agendar novamente
              </ScheduleButton>
            </Box>
          </ModalError>
        )}
      </>
    );
  }
}

SchedulingForm.propTypes = {
  classes: PropTypes.object.isRequired,
  scrollToErrorMessage: PropTypes.func,
  customer: PropTypes.object.isRequired,
  schedules: PropTypes.array.isRequired,
  schedulingFormStore: PropTypes.instanceOf(SchedulingFormStore).isRequired,
  availableDatesStore: PropTypes.instanceOf(AvailableDatesStore).isRequired,
  modalStore: PropTypes.instanceOf(ModalStore).isRequired,
};

SchedulingForm.defaultProps = {
  scrollToErrorMessage: () => {},
};

export default withStyles(schedulingFormStyles)(
  inject(
    'schedulingFormStore',
    'availableDatesStore',
    'modalStore'
  )(observer(SchedulingForm))
);
